
/* injects from baggage-loader */
require('./style.scss');

import React from "react";
import { t } from "../../../helpers/translator";
import { ClosePopup } from "../../../actions/ui";
import { connect } from "react-redux";
import successPic from '../../../images/success-icon-2.png'
const SuccessPopup = ({
    title,
    subTitle,
    dispatch
}) => {
    return (
        <div className='success-container'>
            <p className='success-container-title'>{t(title)}</p>
            <p className='success-container-sub-title'>{t(subTitle)}</p>
            <img alt='success-icon' src={successPic} />
            <button
                className='button-view-normal-m cancel'
                onClick={() => dispatch(ClosePopup(true))}
            >
                Done
            </button>
        </div>
    )
}
export default connect()(SuccessPopup)